import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';

import { register } from 'swiper/element/bundle';
import { MenuComponent } from './components/menu/menu.component';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [IonApp, IonRouterOutlet, MenuComponent],
})
export class AppComponent {
  constructor(private router: Router) {}

    navigate(item) {
    if (item.route) {
      this.router.navigate([item.route]);
    }
  }
}
